import script from "./permissionManage.vue?vue&type=script&setup=true&lang=js"
export * from "./permissionManage.vue?vue&type=script&setup=true&lang=js"

import "./permissionManage.vue?vue&type=style&index=0&id=11caa630&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11caa630"]])

export default __exports__